








































import Vue from 'vue'
import mixin from './cardmixin.vue'
import { IotStatisticServiceProxy } from '@/service-proxies/app-v2/iot-console.service-proxies'
const iotStatisticProxy = new IotStatisticServiceProxy()
export default Vue.extend({
  name: 'gateway-statue-record-card',
  mixins: [mixin],
  data() {
    return {
      color: [
        '#73D13D',
        '#D8D8D8',
        '#FA554C',
      ],
      total:0,
      online:0,
      columns: [],
      data: [],
      onlineState: '1',
      badgeStatus: [],
      myChart: null,
      echartData: [],
      loading: false
    }
  },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  created() {
  },
  mounted() {
    this.getList()
  },
  watch: {
    chartOption: {
      handler(val) {
        if (this.myChart) {
          this.myChart.setOption(val, true)
        }
      },
      deep: true
    },
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    getList() {

      this.loading=true;
      iotStatisticProxy.tenantGatewayCount()
      .then(res=>{
        const arr=[];

        arr.push({name:'online', value:res.online});
        arr.push({name:'offline', value:res.offline});
        arr.push({name:'not_online', value:res.neverOnline});
        this.total = res.total;
        this.online = res.online;
        this.echartData=arr;
        this.$nextTick().then(()=>{
          this.myChart = this.$echarts.init(this.$refs.myChart)
          this.myChart.setOption(this.chartOption)
        });

      })
      .finally(()=>{
        this.loading=false;
      });



    },
  },
  computed: {
    chartOption() {
      let title = this.$t('gateway_total_num')

      let formatNumber = function(num) {
        let reg = /(?=(\B)(\d{3})+$)/g
        return num.toString().replace(reg, ',')
      }
      let total = this.echartData.reduce((a, b) => {
        return a + b.value * 1
      }, 0)

      let option = {
        color: this.color,
        title: [
          {
            text: '{val|' + formatNumber(total) + '}\n{name|' + title + '}',
            top: 'center',
            left: 'center',
            textStyle: {
              rich: {
                align: 'canter',
                name: {
                  fontSize: 16,
                  fontWeight: 'bold',
                  color: 'rgba(0,0,0,0.85)',
                  padding: [10, 0]
                },
                val: {
                  fontSize: 32,
                  lineHeight: 40,
                  fontWeight: 'bold',
                  color: '#4A90E2'
                }
              }
            }
          }
        ],
        series: [
          {
            type: 'pie',
            radius: [70, 94],
            center: ['50%', '50%'],
            data: this.echartData,
            hoverAnimation: false,
            itemStyle: {
              normal: {
                borderWidth: 2
              }
            },
            labelLine: {
              normal: {
                length: 20,
                length2: 120,
                lineStyle: {
                  color: '#e6e6e6'
                }
              }
            },
            label: {
              show: false
            }
          }
        ]
      }
      return option
    }
  },
})
